<template>
	<div class="full" id="compensationChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			
		},
		data() {
			return {
				chart: null,
				data:[],
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.statisticsChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				this.statisticsChart()
			},
			statisticsChart() {
				let data = JSON.parse(JSON.stringify(this.data))
				let xarr = []
				let series = []
				let seriesdata = []
				console.log(data,123123)
				for(let i in data){
					xarr.push(i)
					seriesdata.push(data[i])
				}
				series.push({
					name: '赔付金额',
					type: 'line',
					label: {
						show: true,
						position: 'top'
					},
					emphasis: {
						focus: 'series'
					},
					data: seriesdata
				})
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('compensationChart'))
				}
				this.chart.setOption({
					title: {
						text: '赔付金额',
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: []
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '2%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})
				//console.log(xarr,this.tableData)
			}
		},
		components: {

		}
	}
</script>